export const MISSING_USER_IMAGE = "/icons/missing-picture.png";
